(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("lcQ3o", function(module, exports) {
const $f70318c2c4e36215$var$headerDropdownItems = document.querySelectorAll(".i-header-dropdown");
$f70318c2c4e36215$var$headerDropdownItems.forEach((item)=>{
    const close = item.querySelector(".i-header-dropdown__close");
    const formActions = [
        {
            selector: ".--js-open-login",
            className: "--login"
        },
        {
            selector: ".--js-open-registration",
            className: "--registration"
        },
        {
            selector: ".--js-open-forgotten-password",
            className: "--forgotten-password"
        }
    ];
    const openForm = (className)=>{
        item.classList.remove("--login", "--registration", "--forgotten-password");
        item.classList.add(className);
    };
    formActions.forEach(({ selector: selector, className: className })=>{
        const openFormLink = item.querySelectorAll(selector);
        openFormLink.forEach((link)=>{
            link.addEventListener("click", (e)=>{
                e.preventDefault();
                openForm(className);
            });
        });
    });
    close?.addEventListener("click", ()=>{
        item.classList.remove("--open");
    });
});
document.addEventListener("click", (e)=>{
    const target = e.target;
    if (target instanceof HTMLElement && !target.closest(".i-header-dropdown, .i-user")) $f70318c2c4e36215$var$headerDropdownItems.forEach((item)=>item.classList.remove("--open"));
});

});

})();
//# sourceMappingURL=header-dropdown-item.792f3281.js.map
